// package imports
import React, { useRef } from 'react';
import { Box } from '@mui/material';
import { Session } from 'next-auth';

// local imports
import { MegaMenuSection, SiteHeaderType } from './SiteHeaderTypes';
import LogoBox from './DesktopMegaMenuComponents/LogoBox';
import NavigationToggleButton from './DesktopMegaMenuComponents/NavigationToggleButton';
import MegaMenuTransition from './DesktopMegaMenuComponents/MegaMenuTransition';
import MegaMenuNav from './DesktopMegaMenuComponents/MegaMenuNav';
import MegaMenuContainer from './DesktopMegaMenuComponents/MegaMenuContainer';
import { isCustomer } from 'services/subscriptionUtils';
import { LessonPlan } from 'types/AgilityTypes';

const DesktopMegaMenu = ({
  headerFields,
  session,
  lessonPlanOfTheWeek,
}: {
  headerFields: SiteHeaderType;
  session: Session | null;
  lessonPlanOfTheWeek?: LessonPlan;
}) => {
  const headerRef = useRef<HTMLDivElement>(null);

  const shouldDisplaySesction = (section: MegaMenuSection) => {
    if (section.fields.freeAccountDisplayOnly === 'true') {
      if (session?.user && !isCustomer(session?.user)) {
        return true;
      }
      return false;
    }
    if (section.fields.subscriptionRequiredForDisplay === 'true') {
      if (isCustomer(session?.user)) {
        return true;
      }
      return false;
    }
    if (section.fields.loggedInUserDisplayOnly === 'true') {
      if (session?.user) {
        return true;
      }
      return false;
    }
    if (section.fields.notLoggedInUserOnlyDisplay === 'true') {
      if (session?.user) {
        return false;
      }
      return true;
    }
    return true;
  };

  return (
    <Box
      sx={{
        '@media (max-width: 1024px)': {
          display: 'none',
        },
      }}
      ref={headerRef}
    >
      <Box
        id="desktop-mega-menu"
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          height: '74px',
          '@media (min-width: 1024px)': {
            ml: '1rem',
            mr: '1rem',
          },
          '@media (min-width: 1224px)': {
            ml: '4rem',
            mr: '4rem',
          },
        }}
      >
        <LogoBox megaMenuLogo={headerFields.fields.megaMenuLogo} />
        {headerFields.fields.megaMenuSections.map((section) => {
          if (shouldDisplaySesction(section)) {
            return (
              <NavigationToggleButton
                key={section.contentID}
                section={section}
                session={session}
              />
            );
          }
          return null;
        })}
      </Box>
      <MegaMenuContainer headerRef={headerRef}>
        <MegaMenuTransition>
          <MegaMenuNav
            headerFields={headerFields}
            session={session}
            lessonPlanOfTheWeek={lessonPlanOfTheWeek}
          />
        </MegaMenuTransition>
      </MegaMenuContainer>
    </Box>
  );
};

export default DesktopMegaMenu;
